import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, AuthField, SubmitButton } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (form.password !== form.confirm) { setError("Passwords don't match"); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      setUser(false);
      toast.success("Password updated. Log in with your new password.");
      navigate("/login", { replace: true });
    } catch (err) { setError(errorMessage(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password" sub="Use at least 8 characters."
      footer={<Link to="/forgot-password" className="font-semibold text-slate-900 underline" data-testid="reset-request-new-link">Request a new link</Link>}>
      {!token ? <p className="text-red-600" data-testid="reset-missing-token">This reset link is invalid. Request a new one.</p> : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <AuthField label="New password" type="password" autoComplete="new-password" required value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reset-password-input" />
          <AuthField label="Confirm new password" type="password" autoComplete="new-password" required value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="reset-confirm-input" />
          {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
          <SubmitButton loading={loading} testId="reset-submit-button">Update password</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
